import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { TransactionRefundRowDetails } from './TransactionRefundRowDetails';
import { TransactionMoreDetailsButton } from './TransactionMoreDetailsButton';
import BrowserUtils from '../../../utils/BrowserUtils';
import { isBOrVMRetail } from '../../../utils/BrandUtils';

let showSelectionClass = '';

class TransactionInformationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.checkBoxClick = this.checkBoxClick.bind(this);
    this.onTableTagClick = this.onTableTagClick.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.isPendingRefund = this.isPendingRefund.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    if (!nextprops.showSelectionTag && this.props.showSelectionTag) {
      document.getElementById(`tag${this.props.data.id}`).checked = false;
    }
  }
  showRadio() {}
  checkBoxClick(e) {
    const value = e.target.checked;
    this.props.onRowSelect(this.props.data, value);
  }
  onTableTagClick(event) {
    event.stopPropagation();

    if (!this.props.showSelectionTag) {
      this.props.onTableTagClick(this.props.data);
    } else {
      if (document.getElementById(`tag${this.props.data.id}`).checked) {
        document.getElementById(`tag${this.props.data.id}`).checked = false;
        this.props.onRowSelect(this.props.data, false);
      } else {
        document.getElementById(`tag${this.props.data.id}`).checked = true;
        this.props.onRowSelect(this.props.data, true);
      }
    }
  }
  onRowClick(event) {
    event.stopPropagation();

    if (!this.props.showSelectionTag && BrowserUtils.isExtraSmallMobileView()) {
      this.handleMoreDetailsClick();
    } else {
      if (document.getElementById(`tag${this.props.data.id}`).checked) {
        document.getElementById(`tag${this.props.data.id}`).checked = false;
        this.props.onRowSelect(this.props.data, false);
      } else {
        document.getElementById(`tag${this.props.data.id}`).checked = true;
        this.props.onRowSelect(this.props.data, true);
      }
    }
  }

  handleMoreDetailsClick = () => {
    const { onMoreDetailsClick, data } = this.props;

    onMoreDetailsClick({
      selectedTransactionId: data.id,
    });
  };

  isPendingRefund() {
    const {
      data: { isRefund, posted },
    } = this.props;

    return isRefund && !posted;
  }

  render() {
    let rowCustomClass = this.props.rowCustomClass;
    this.props.showSelectionTag
      ? (showSelectionClass = 'js-stick--slide_right')
      : (showSelectionClass = '');

    let inProgressClassName = '';
    if (this.props.showSelectionTag && !this.props.data.posted) {
      showSelectionClass = 'js-stick--slide_right';
      inProgressClassName = 'js-stick--inProgress';
    }

    let balanceColumn = null;
    if (this.props.accountType !== 'credit_card') {
      if (this.props.data.posted) {
        balanceColumn = (
          <p
            className="datatable__info__balance__value"
            onClick={this.onRowClick}
          >
            {this.props.data.balance}
          </p>
        );
      } else {
        balanceColumn = (
          <div
            className="transaction-pending"
            onClick={this.props.openTransactionInProgressPopUp}
          >
            <svg
              enableBackground="new 0 0 91 91"
              height="28px"
              id="Layer_1"
              version="1.1"
              viewBox="0 0 91 91"
              width="28px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M45.2,18.577c-15.243,0-27.645,12.404-27.645,27.646c0,15.244,12.401,27.646,27.645,27.646   c15.244,0,27.645-12.402,27.645-27.646C72.845,30.981,60.444,18.577,45.2,18.577z M45.2,70.47   c-13.368,0-24.244-10.875-24.244-24.246c0-13.369,10.876-24.246,24.244-24.246c13.369,0,24.245,10.877,24.245,24.246   C69.445,59.595,58.569,70.47,45.2,70.47z" />
                <polygon points="46.985,26.272 43.585,26.272 43.585,47.925 54.485,47.925 54.485,44.524 46.985,44.524  " />
                <rect height="4.424" width="3.4" x="43.585" y="61.72" />
                <rect height="3.4" width="4.36" x="25.229" y="44.524" />
                <rect height="3.4" width="4.36" x="60.813" y="44.524" />
                <rect
                  height="3.402"
                  transform="matrix(0.7378 0.6751 -0.6751 0.7378 31.4782 -12.701)"
                  width="4.36"
                  x="29.907"
                  y="32.465"
                />
                <rect
                  height="3.401"
                  transform="matrix(-0.738 -0.6748 0.6748 -0.738 62.1598 140.4834)"
                  width="4.356"
                  x="56.174"
                  y="56.474"
                />
                <rect
                  height="4.361"
                  transform="matrix(-0.7377 -0.6751 0.6751 -0.7377 17.6811 125.4726)"
                  width="3.399"
                  x="31.514"
                  y="57.121"
                />
                <rect
                  height="4.36"
                  transform="matrix(0.7377 0.6751 -0.6751 0.7377 37.3121 -29.9663)"
                  width="3.399"
                  x="55.523"
                  y="30.858"
                />
              </g>
            </svg>
          </div>
        );
      }
    }

    const archivedTagCss = this.props.data.archived ? 'archived-tag' : '';

    const isPendingRefund = this.isPendingRefund();
    return (
      <li
        className={cx('datatable__row', {
          'transaction-refund-row': isPendingRefund,
        })}
        onClick={this.showRadio}
      >
        <div
          ref="tagCheckBox"
          className={`datatable__tag ${showSelectionClass}`}
        >
          <div className={`datatable__select__tag ${inProgressClassName}`}>
            <input
              id={`tag${this.props.data.id}`}
              type="checkbox"
              name="tag"
              ref="tag"
              value=""
              onChange={this.checkBoxClick}
            />
            <label
              htmlFor={`tag${this.props.data.id}`}
              className="datatable__tagging__selectbox"
            />
          </div>
        </div>
        <div ref="rowInfo" className={'datatable__info'}>
          <div>
            <div className="datatable__info__account">
              <p
                className={`datatable__info__account__name padding__bottom row-open ${rowCustomClass} `}
                onClick={this.onRowClick}
              >
                {this.props.data.description}
              </p>
              {isBOrVMRetail() &&
                this.props.data.tag !== 'Untagged' &&
                this.props.data.posted && (
                  <p
                    className={`datatable__info__account__tag ${archivedTagCss}`}
                    onClick={(event) => this.onTableTagClick(event)}
                  >
                    <span className={'icon icon-tag'} />
                    <span>{this.props.data.tag}</span>
                  </p>
                )}
            </div>
            {isBOrVMRetail() && (
              <div className="datatable__info__card">
                <p
                  className="datatable__info__card__value padding__bottom"
                  onClick={this.onRowClick}
                >
                  {this.props.data.amount}
                </p>
                <p
                  className="datatable__info__card__type e-ellipsis"
                  onClick={this.onRowClick}
                >
                  {this.props.data.type}
                </p>
              </div>
            )}
            {!isBOrVMRetail() && (
              <div className="datatable__info__debit datatable__info__card">
                <p
                  className="datatable__info__debit__value datatable__info__card__value"
                  onClick={this.onRowClick}
                >
                  {this.props.data.debit}
                </p>
              </div>
            )}
            {!isBOrVMRetail() && (
              <div className="datatable__info__card datatable__info__credit">
                <p
                  className="datatable__info__credit__value datatable__info__card__value"
                  onClick={this.onRowClick}
                >
                  {this.props.data.credit}
                </p>
              </div>
            )}
            {this.props.accountType !== 'credit_card' ? (
              <div className="datatable__info__balance padding__bottom">
                {balanceColumn}
              </div>
            ) : null}
            <div className="datatable__info__more padding__bottom">
              <TransactionMoreDetailsButton
                onClick={this.handleMoreDetailsClick}
              />
            </div>
          </div>
        </div>
        {isPendingRefund && (
          <div className="transaction-refund-wrapper">
            <TransactionRefundRowDetails content={this.props.content} />
          </div>
        )}
      </li>
    );
  }
}
TransactionInformationComponent.propTypes = {
  data: PropTypes.object,
  onRowSelect: PropTypes.func,
  className: PropTypes.string,
  accountType: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.string,
  showSelectionTag: PropTypes.bool,
  onMoreDetailsClick: PropTypes.func,
};
// Specifies the default values for props:
TransactionInformationComponent.defaultProps = {
  className: 'btn',
  btnName: '',
};
export default TransactionInformationComponent;
